var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"epb-link",class:[("epb-link--" + _vm.color),
   { 'epb-link--underlined': _vm.underlined },
   { 'epb-link--disabled': _vm.disabled }],attrs:{"disabled":_vm.disabled}},[(!!_vm.icon)?_c('span',{staticClass:"epb-link__icon",class:[ ("eicon-" + _vm.icon),
        ("epb-link__icon--" + _vm.iconPosition),
        ("epb-link__icon--" + _vm.iconSize)]}):_vm._e(),_c('span',{staticClass:"epb-link__content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }